// AccountAuth.jsx
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CustomerAuthService } from "../../services/CustomerAuthServices";
const AccountAuth = ({ initialMode = "login", onLoginSuccess }) => {
  const navigate = useNavigate();
  const [mode, setMode] = useState(initialMode);
  const [step, setStep] = useState(1);
  // Login fields
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginOtp, setLoginOtp] = useState("");
  // Register fields
  const [regName, setRegName] = useState("");
  const [regEmail, setRegEmail] = useState("");
  const [regPassword, setRegPassword] = useState("");
  const [regPasswordConfirm, setRegPasswordConfirm] = useState("");
  const [regOtp, setRegOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });
  const [resendTimer, setResendTimer] = useState(0);
  const [showLoginPw, setShowLoginPw] = useState(false);
  const [showRegPw, setShowRegPw] = useState(false);
  const [showRegCPw, setShowRegCPw] = useState(false);
  // Resend countdown
  useEffect(() => {
    if (resendTimer <= 0) return;
    const t = setTimeout(() => setResendTimer((x) => x - 1), 1000);
    return () => clearTimeout(t);
  }, [resendTimer]);
  const pickErr = (err) => {
    const d = err?.response?.data;
    if (d?.errors) {
      const k = Object.keys(d.errors)[0];
      if (d.errors[k]?.[0]) return d.errors[k][0];
    }
    return d?.message || null;
  };
  const resetUi = () => {
    setMsg({ type: "", text: "" });
    setStep(1);
    setResendTimer(0);
    setLoginEmail(""); setLoginPassword(""); setLoginOtp("");
    setRegName(""); setRegEmail(""); setRegPassword(""); setRegPasswordConfirm(""); setRegOtp("");
  };
  const switchMode = (m) => {
    resetUi();
    setMode(m);
    navigate(m === "register" ? "/signup" : "/login");
  };
  const handleBack = () => {
    setStep(1);
    setMsg({ type: "", text: "" });
    mode === "login" ? setLoginOtp("") : setRegOtp("");
  };
  // ── Login ──
  // const onSendLoginOtp = async (e) => {
  //   e.preventDefault();
  //   setMsg({ type: "", text: "" });
  //   const email = loginEmail.trim();
  //   const pw = loginPassword.trim();
  //   if (!email || !pw) return setMsg({ type: "err", text: "Email and password are required." });
  //   try {
  //     setLoading(true);
  //     const r = await CustomerAuthService.sendLoginOtp({ email, password: pw });
  //     setMsg({ type: "ok", text: r.message || "OTP sent!" });
  //     setStep(2);
  //     setResendTimer(60);
  //   } catch (err) {
  //     setMsg({ type: "err", text: pickErr(err) || "Failed. Check credentials." });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const onLogin = async (e) => {
    e.preventDefault();
    setMsg({ type: "", text: "" });

    const email = loginEmail.trim();
    const pw = loginPassword.trim();

    if (!email || !pw) {
      return setMsg({
        type: "err",
        text: "Email and password are required.",
      });
    }

    try {
      setLoading(true);

      await CustomerAuthService.login({
        email,
        password: pw,
      });

      setMsg({
        type: "ok",
        text: "Login successful.",
      });

      onLoginSuccess?.();

      setTimeout(() => navigate("/account"), 300);
    } catch (err) {
      setMsg({
        type: "err",
        text: pickErr(err) || "Login failed. Check your email and password.",
      });
    } finally {
      setLoading(false);
    }
  };
  // const onVerifyLoginOtp = async (e) => {
  //   e.preventDefault();
  //   setMsg({ type: "", text: "" });
  //   if (loginOtp.length !== 6) return setMsg({ type: "err", text: "Enter a valid 6-digit OTP." });
  //   try {
  //     setLoading(true);
  //     await CustomerAuthService.verifyLoginOtp({ email: loginEmail, otp: loginOtp });
  //     onLoginSuccess?.();
  //     setTimeout(() => navigate("/account"), 400);
  //   } catch (err) {
  //     setMsg({ type: "err", text: pickErr(err) || "Invalid OTP." });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // ── Register ──
  const onSendRegisterOtp = async (e) => {
    e.preventDefault();
    setMsg({ type: "", text: "" });
    const name = regName.trim();
    const email = regEmail.trim();
    const pw = regPassword.trim();
    const cpw = regPasswordConfirm.trim();
    if (!name || !email || !pw || !cpw) return setMsg({ type: "err", text: "All fields are required." });
    if (pw.length < 6) return setMsg({ type: "err", text: "Password must be at least 6 characters." });
    if (pw !== cpw) return setMsg({ type: "err", text: "Passwords do not match." });
    try {
      setLoading(true);
      const r = await CustomerAuthService.sendRegisterOtp({ name, email, password: pw, password_confirmation: cpw });
      setMsg({ type: "ok", text: r.message || "OTP sent!" });
      setStep(2);
      setResendTimer(60);
    } catch (err) {
      setMsg({ type: "err", text: pickErr(err) || "Failed to send OTP." });
    } finally {
      setLoading(false);
    }
  };

  const onVerifyRegisterOtp = async (e) => {
    e.preventDefault();
    setMsg({ type: "", text: "" });
    if (regOtp.length !== 6) return setMsg({ type: "err", text: "Enter a valid 6-digit OTP." });
    try {
      setLoading(true);
      await CustomerAuthService.verifyRegisterOtp({ email: regEmail, otp: regOtp });
      onLoginSuccess?.();
      setTimeout(() => navigate("/account"), 400);
    } catch (err) {
      setMsg({ type: "err", text: pickErr(err) || "Verification failed." });
    } finally {
      setLoading(false);
    }
  };

  // const handleResend = async () => {
  //   if (resendTimer > 0) return;
  //   if (mode === "login") await onSendLoginOtp({ preventDefault: () => {} });
  //   else await onSendRegisterOtp({ preventDefault: () => {} });
  // };

  const handleResend = async () => {
    if (resendTimer > 0) return;

    // OTP resend is now only for registration
    if (mode === "register") {
      await onSendRegisterOtp({ preventDefault: () => {} });
    }
  };
  const otpEmail = mode === "login" ? loginEmail : regEmail;

  const perks = [
    { icon: "ph-lock-key",      cls: "g", title: "OTP-secured login",     sub: "Two-step verification on every sign-in" },
    { icon: "ph-shopping-cart", cls: "b", title: "Cart & wishlist sync",   sub: "Your items saved across sessions" },
    { icon: "ph-package",       cls: "a", title: "Full order tracking",    sub: "Real-time status on every order" },
    { icon: "ph-lightning",     cls: "r", title: "Fast checkout",          sub: "One-click reorder from history" },
  ];

  return (
    <div className="ap-auth">
      <div className="ap-auth-inner">

        {/* ── Left info panel ── */}
        <div className="ap-auth-info">
          <div className="ap-auth-info-badge">
            <i className="ph ph-shield-check" style={{ fontSize: 11 }} />
            Secure Account Portal
          </div>
          <h2>
            {mode === "login"
              ? <><span>Welcome</span><br />back.</>
              : <>Create your<br /><span>account.</span></>}
          </h2>
          <p>
            {mode === "login"
              ? "Sign in to manage your orders, wishlist, and account settings — all in one place."
              : "Join thousands of shoppers. Create your account in under a minute with OTP verification."}
          </p>
          <div className="ap-auth-perks">
            {perks.map((p) => (
              <div key={p.title} className="ap-auth-perk">
                <div className={`ap-auth-perk-icon ${p.cls}`}>
                  <i className={`ph ${p.icon}`} />
                </div>
                <div className="ap-auth-perk-text">
                  <strong>{p.title}</strong>
                  <span>{p.sub}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Right form card ── */}
        <div className="ap-auth-card">
          <div className="ap-auth-card-hd">
            {step === 1 && (
              <div className="ap-tabs">
                <button className={`ap-tab ${mode === "login" ? "on" : "off"}`} onClick={() => switchMode("login")}>
                  Sign In
                </button>
                <button className={`ap-tab ${mode === "register" ? "on" : "off"}`} onClick={() => switchMode("register")}>
                  Create Account
                </button>
              </div>
            )}
            {/* <div className="ap-auth-heading">
              {step === 2
                ? mode === "login" ? "Verify your identity" : "Verify your email"
                : mode === "login" ? "Sign in to your account" : "Create your account"}
            </div> */}
            <div className="ap-auth-heading">
              {mode === "register" && step === 2
                ? "Verify your email"
                : mode === "login"
                ? "Sign in to your account"
                : "Create your account"}
            </div>

            <div className="ap-auth-sub">
              {mode === "register" && step === 2
                ? `Enter the 6-digit code sent to ${otpEmail}`
                : mode === "login"
                ? "Enter your email and password to continue"
                : "Fill in your details to get started"}
            </div>
            <div className="ap-auth-sub">
              {step === 2
                ? `Enter the 6-digit code sent to ${otpEmail}`
                : mode === "login"
                ? "Enter your email and password to continue"
                : "Fill in your details to get started"}
            </div>
          </div>

          <div className="ap-auth-card-bd">
            {msg?.text && (
              <div className={`ap-alert ${msg.type === "err" ? "err" : "ok"}`}>
                <i
                  className={`ph ${msg.type === "err" ? "ph-warning-circle" : "ph-check-circle"}`}
                  style={{ fontSize: 15, flexShrink: 0 }}
                />
                {msg.text}
              </div>
            )}

            {/* Login Step 1 */}
            {mode === "login" && step === 1 && (
              // <form onSubmit={onSendLoginOtp}>
              <form onSubmit={onLogin}>
                <div className="ap-field">
                  <label className="ap-label">Email address</label>
                  <input className="ap-input" type="email" placeholder="you@example.com"
                    value={loginEmail} onChange={(e) => setLoginEmail(e.target.value)} disabled={loading} />
                </div>
                <div className="ap-field">
                  <label className="ap-label">Password</label>
                  <div className="ap-input-wrap">
                    <input className="ap-input" type={showLoginPw ? "text" : "password"} placeholder="Your password"
                      value={loginPassword} onChange={(e) => setLoginPassword(e.target.value)} disabled={loading} />
                    <button type="button" className="ap-eye" onClick={() => setShowLoginPw(!showLoginPw)}>
                      <i className={`ph ${showLoginPw ? "ph-eye" : "ph-eye-slash"}`} />
                    </button>
                  </div>
                  <div className="ap-hint">Use your email and password to sign in</div>
                </div>
                <div className="ap-forgot"><Link to="/forgot-password">Forgot password?</Link></div>
                <button type="submit" className="ap-submit" disabled={loading}>
                  {/* {loading ? "Verifying…" : "Continue →"} */}
                  {loading ? "Signing in…" : "Sign In"}
                </button>
                <div className="ap-switch">
                  Don't have an account?{" "}
                  <button type="button" className="ap-switch-btn" onClick={() => switchMode("register")}>
                    Sign up free
                  </button>
                </div>
              </form>
            )}

            {/* Login Step 2 (OTP) */}
            {/* {mode === "login" && step === 2 && (
              <form onSubmit={onVerifyLoginOtp}>
                <div className="ap-otp-notice">
                  <i className="ph ph-envelope-open" style={{ fontSize: 15, flexShrink: 0, marginTop: 1 }} />
                  <span>Code sent to <strong>{otpEmail}</strong></span>
                </div>
                <div className="ap-otp-wrap">
                  <input className="ap-otp-input" type="text" placeholder="000000"
                    value={loginOtp}
                    onChange={(e) => { const v = e.target.value.replace(/\D/g, ""); if (v.length <= 6) setLoginOtp(v); }}
                    disabled={loading} maxLength={6} />
                  <div className="ap-otp-info">Enter the 6-digit code above</div>
                </div>
                <div className="ap-resend">
                  {resendTimer > 0
                    ? <span>Resend in <strong style={{ color: "#111827" }}>{resendTimer}s</strong></span>
                    : <button type="button" className="ap-resend-btn" onClick={handleResend}>Resend code</button>}
                </div>
                <button type="submit" className="ap-submit" disabled={loading || loginOtp.length !== 6}>
                  {loading ? "Verifying…" : "Verify & Sign In"}
                </button>
                <button type="button" className="ap-back" onClick={handleBack} disabled={loading}>
                  ← Back to login
                </button>
              </form>
            )} */}

            {/* Register Step 1 */}
            {mode === "register" && step === 1 && (
              <form onSubmit={onSendRegisterOtp}>
                <div className="ap-field">
                  <label className="ap-label">Full name</label>
                  <input className="ap-input" type="text" placeholder="John Doe"
                    value={regName} onChange={(e) => setRegName(e.target.value)} disabled={loading} />
                </div>
                <div className="ap-field">
                  <label className="ap-label">Email address</label>
                  <input className="ap-input" type="email" placeholder="you@example.com"
                    value={regEmail} onChange={(e) => setRegEmail(e.target.value)} disabled={loading} />
                </div>
                <div className="ap-field">
                  <label className="ap-label">Password</label>
                  <div className="ap-input-wrap">
                    <input className="ap-input" type={showRegPw ? "text" : "password"} placeholder="Min. 6 characters"
                      value={regPassword} onChange={(e) => setRegPassword(e.target.value)} disabled={loading} />
                    <button type="button" className="ap-eye" onClick={() => setShowRegPw(!showRegPw)}>
                      <i className={`ph ${showRegPw ? "ph-eye" : "ph-eye-slash"}`} />
                    </button>
                  </div>
                </div>
                <div className="ap-field">
                  <label className="ap-label">Confirm password</label>
                  <div className="ap-input-wrap">
                    <input className="ap-input" type={showRegCPw ? "text" : "password"} placeholder="Repeat your password"
                      value={regPasswordConfirm} onChange={(e) => setRegPasswordConfirm(e.target.value)} disabled={loading} />
                    <button type="button" className="ap-eye" onClick={() => setShowRegCPw(!showRegCPw)}>
                      <i className={`ph ${showRegCPw ? "ph-eye" : "ph-eye-slash"}`} />
                    </button>
                  </div>
                  <div className="ap-hint">We'll verify your email with a one-time code</div>
                </div>
                <button type="submit" className="ap-submit" disabled={loading}>
                  {loading ? "Sending code…" : "Continue →"}
                </button>
                <div className="ap-switch">
                  Already have an account?{" "}
                  <button type="button" className="ap-switch-btn" onClick={() => switchMode("login")}>
                    Sign in
                  </button>
                </div>
              </form>
            )}

            {/* Register Step 2 (OTP) */}
            {mode === "register" && step === 2 && (
              <form onSubmit={onVerifyRegisterOtp}>
                <div className="ap-otp-notice">
                  <i className="ph ph-envelope-open" style={{ fontSize: 15, flexShrink: 0, marginTop: 1 }} />
                  <span>Code sent to <strong>{otpEmail}</strong></span>
                </div>
                <div className="ap-otp-wrap">
                  <input className="ap-otp-input" type="text" placeholder="000000"
                    value={regOtp}
                    onChange={(e) => { const v = e.target.value.replace(/\D/g, ""); if (v.length <= 6) setRegOtp(v); }}
                    disabled={loading} maxLength={6} />
                  <div className="ap-otp-info">Enter the 6-digit code above</div>
                </div>
                <div className="ap-resend">
                  {resendTimer > 0
                    ? <span>Resend in <strong style={{ color: "#111827" }}>{resendTimer}s</strong></span>
                    : <button type="button" className="ap-resend-btn" onClick={handleResend}>Resend code</button>}
                </div>
                <button type="submit" className="ap-submit" disabled={loading || regOtp.length !== 6}>
                  {loading ? "Creating account…" : "Verify & Create Account"}
                </button>
                <button type="button" className="ap-back" onClick={handleBack} disabled={loading}>
                  ← Back to details
                </button>
              </form>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default AccountAuth;